var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuoted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.05 31.29c.25 0 .5-.09.69-.28l8.68-8.68 3.88 3.88c.38.38.99.38 1.37 0L27.88 17l7.83 7.83c.36.36 1.01.36 1.37 0L55.93 5.96v6.48c0 .54.43.97.97.97s.97-.43.97-.97V3.62c0-.13-.03-.25-.07-.37a.947.947 0 0 0-.89-.59h-8.98c-.54 0-.97.43-.97.97s.43.97.97.97h6.63L36.38 22.78l-7.83-7.83c-.36-.36-1.01-.36-1.37 0l-9.21 9.21-3.88-3.88a.966.966 0 0 0-1.37 0l-9.36 9.35a.966.966 0 0 0 .69 1.65z",
    fill: "#627384",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54 60.41H2.43V4.42c0-.54-.43-.97-.97-.97s-.97.43-.97.97v56.96c0 .54.43.97.97.97h62.08c.54 0 .97-.43.97-.97s-.43-.97-.97-.97z",
    fill: "#627384",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82 37.34c-.54 0-.97.43-.97.97V57.2c0 .54.43.97.97.97h9.19c.54 0 .97-.43.97-.97V38.31c0-.54-.43-.97-.97-.97zm8.22 18.89H8.79V39.28h7.25zM22.81 31.6c-.54 0-.97.43-.97.97V57.2c0 .54.43.97.97.97H32c.54 0 .97-.43.97-.97V32.57c0-.54-.43-.97-.97-.97zm8.22 24.63h-7.25V33.54h7.25zM37.8 28.67c-.54 0-.97.43-.97.97V57.2c0 .54.43.97.97.97h9.19c.54 0 .97-.43.97-.97V29.64c0-.54-.43-.97-.97-.97zm8.22 27.56h-7.25V30.61h7.25zM51.82 24.79V57.2c0 .54.43.97.97.97h9.19c.54 0 .97-.43.97-.97V24.79c0-.54-.43-.97-.97-.97h-9.19c-.54 0-.97.43-.97.97zm1.94.97h7.25v30.47h-7.25z",
    fill: "#627384",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoted);
export default __webpack_public_path__ + "static/media/icon-quoted.ed7993535c7890b934558ddec6117796.svg";
export { ForwardRef as ReactComponent };